export const VISION_DATA_OCR_AUTHORIZATION = 'v1s10nD4t4I5c0oL';
